import { AppConstants } from '../../AppConstants'
import { InformationData } from '../../data/InformationData'
import styles from './footer.module.css'
import { AiFillGithub, AiOutlineMail, AiFillLinkedin } from 'react-icons/ai'
const Footer = () => {
    const { LinkedIn, GitHub, Email } = AppConstants.SocialLinks;
    
    return (
        <footer className={styles.footer}>
            <div className="container">
                <div className={styles.flex}>
                    <div className={styles['footer-contact']}>
                        <div className={styles["mail-container"]}>
                            <AiOutlineMail size={30} />
                            <p>{InformationData.Email}</p>
                        </div>
                    </div>
                    <ul>
                        {
                            AppConstants.NavLinks.map((link) => {
                                return (
                                    <li key={link.id}><a href={`#${link.id}`}>{link.label}</a></li>
                                )
                            })
                        }
                    </ul>
                    <div className={styles.icon}>
                        <a href={LinkedIn} target='_blank' rel='noreferrer' aria-label="LinkedIn profile">
                            <AiFillLinkedin size={32} />
                        </a>
                        <a href={GitHub} target='_blank' rel='noreferrer' aria-label="GitHub profile">
                            <AiFillGithub size={32} />
                        </a>
                        <a href={`mailto:${Email}`} aria-label="Send email">
                            <AiOutlineMail size={32} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
